import React, { useState } from 'react'
import AuctionViewHistory from '../components/AuctionViewHistory/AuctionViewHistory'

const AuctionViewHistoryPage = () => {
  return (
    <>
      <AuctionViewHistory />
    </>
  )
}

export default AuctionViewHistoryPage
